import axios from "axios";

export default {
    state: () => ({
        paymentList : null,
        refundList : null,
        couponList : null,
        couponId : 0
    }),
    mutations: {
        setPaymentList:function (state,paymentList){
            state.paymentList = paymentList;
        },
        setRefundList:function (state,refundList){
            state.refundList = refundList;
        },
        setCouponList:function (state,couponList){
            state.couponList = couponList;
        },
        setCouponId:function (state,couponId){
            state.couponId = couponId;
        },
    },
    getters: {
        getPaymentList : state => {
            return state.paymentList
        },
        getRefundList : state => {
            return state.refundList
        },
        getCouponList : state => {
            return state.couponList
        },
        getCouponId : state => {
            return state.couponId;
        }
    },
    actions:{
        loadPaymentList(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/payment", {headers})
                .then((response) => {
                    context.commit("setPaymentList", response.data);
                    return response.data;
                })
        },
        loadCouponList(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/coupon", {headers})
                .then((response) => {
                    context.commit("setCouponList", response.data);
                    return response.data;
                })
        }
    }
}

